import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { usePoliciesQuery } from "@common/hooks/useSelectableItemQueries";
import { ITaskPoliciesProps } from "./TaskPolicies";
import { post } from "@common/api/apiShared";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation";

export default function useTaskPoliciesHooks(props: ITaskPoliciesProps) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();

    const { data: policies, isLoading: policiesIsLoading } = usePoliciesQuery(true);

    const saveMutation = useDotLegalMutation(update, {
        onSuccess: () => {
            props.onPoliciesAdded();
            snackbar.show(translateString("policyAdded"));
        },
    });

    function onPolicySelected(policyId: string | null) {
        if (policyId) {
            saveMutation.mutate(policyId);
        }
    }

    function update(policyId: string) {
        return post<string>(`/task/${props.taskId}/policies`, policyId);
    }

    return { policies, policiesIsLoading, onPolicySelected };
}
